/* eslint-disable max-lines */
import { Landing } from 'modules/landings-info/landings-info-types';
import { ServiceCategory } from 'modules/service-categories/service-categories-types';
import i18n from '../../../i18n.config';
import { SERVICES_MAIN_CDN_PATH } from './services-main-constants';
import { ActualServiceStructure, ServiceAddInfo } from './services-main-types';

const getServicesOtherData = (): ServiceAddInfo[] => [
  {
    serviceId: '1063',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/popular/317.jpg/317.jpg`,
    description: '',
  },
  {
    serviceId: '321',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/popular/321.jpg/321.jpg`,
    description: '',
  },
  {
    serviceId: '323',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/popular/323.jpg/323.jpg`,
    description: '',
  },
  {
    serviceId: '314',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/popular/314.jpg/314.jpg`,
    description: '',
  },
  {
    serviceId: '337',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/popular/337.jpg/337.jpg`,
    description: '',
  },
  {
    serviceId: '331',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/popular/331.jpg/331.jpg`,
    description: '',
  },
  {
    serviceId: '334',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/popular/334.jpg/334.jpg`,
    description: '',
  },
  {
    serviceId: '2133',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/instore/2133.jpg/2133.jpg`,
    description: i18n.t('instore-section.water-analysis-description'),
  },
  {
    serviceId: '2134',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/instore/2134.jpg/2134.jpg`,
    description: i18n.t('instore-section.tinting-description'),
  },
  {
    serviceId: '2135',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/instore/2135.jpg/2135.jpg`,
    description:  i18n.t('instore-section.overlock-description'),
  },
  {
    serviceId: '2136',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/instore/2136.jpg/2136.jpg`,
    description: i18n.t('instore-section.sewing-curtains-description'),
  },
  {
    serviceId: '2137',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/instore/2137.jpg/2137.jpg`,
    description: i18n.t('instore-section.wood-processing-description'),
  },
  {
    serviceId: '2138',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/instore/2138.jpg/2138.jpg`,
    description: i18n.t('instore-section.glass-cutting-description'),
  },
  {
    serviceId: '3628',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/instore/3628.jpg/3628.jpg`,
    description: i18n.t('instore-section.trimming-roller-blinds-description'),
  },
  {
    serviceId: '3681',
    imgSrc: `${SERVICES_MAIN_CDN_PATH}/instore/3681.jpg/3681.jpg`,
    description: i18n.t('instore-section.repotting-indoor-plants'),
  },
];

// Получаем ID всех доступных для региона лендингов и услуг
const getLandingNames = (landingsList: Landing[] | null) =>
  landingsList?.map(landing => landing.landingName);
const getServiceCategoriesNames = (serviceCategoriesList: ServiceCategory[] | null) =>
  serviceCategoriesList?.map(service => service.topCategoryId.toString());

// Получаем массив необходимых данных по доступным лендингам и услугам
export const getFinalServicesData = (
  services: string[],
  landingsList: Landing[] | null,
  serviceCategoriesList: ServiceCategory[] | null,
) => {
  const serviceOtherDataList = getServicesOtherData();

  return services.reduce((res: ActualServiceStructure[], serviceId: string) => {
    if (
      getLandingNames(landingsList)?.includes(serviceId) ||
      getServiceCategoriesNames(serviceCategoriesList)?.includes(serviceId)
    ) {
      const serviceData =
        landingsList?.find(landing => landing.landingName === serviceId) ||
        serviceCategoriesList?.find(
          serviceCategory => serviceCategory.topCategoryId.toString() === serviceId
        );
      const serviceOtherData = serviceOtherDataList.find(imageData => imageData.serviceId === serviceId);
      const serviceCategorySeoUrl =
        (serviceData as ServiceCategory).topCategoryType === 'INSTORE'
          ? `${(serviceData as ServiceCategory).topCategoryUrl}/`
          : (serviceData as ServiceCategory).topCategoryUrl;
      const actualServiceCommonData: ActualServiceStructure = {
        serviceName:
          (serviceData as Landing).defaultTitle || (serviceData as ServiceCategory).topCategoryName,
        serviceAddName:
          serviceOtherData?.topCategoryName || (serviceData as Landing).addTitle || (serviceData as ServiceCategory).topCategoryName,
        serviceUrl: (serviceData as Landing).url || serviceCategorySeoUrl,
        serviceImage: serviceOtherData?.imgSrc || (serviceData as Landing).imageSrc || undefined,
      };
      res.push(actualServiceCommonData);
    }
    return res;
  }, []);
}

// Получаем массив необходимых данных для instore услуг
export const getFinalInstoreData = (services: string[], serviceCategoriesList: ServiceCategory[] | null) => {
  const serviceOtherDataList = getServicesOtherData();

  return services.reduce((res: ActualServiceStructure[], serviceId: string) => {
    if (getServiceCategoriesNames(serviceCategoriesList)?.includes(serviceId)) {
      const serviceData = serviceCategoriesList?.find(
        serviceCategory => serviceCategory.topCategoryId.toString() === serviceId
      );
      const serviceOtherData = serviceOtherDataList.find(imageData => imageData.serviceId === serviceId);
      const actualServiceCommonData: ActualServiceStructure = {
        serviceName: (serviceData as ServiceCategory).topCategoryName,
        serviceUrl: `${(serviceData as ServiceCategory).topCategoryUrl}/`,
        serviceImage: serviceOtherData?.imgSrc,
        serviceDescription: serviceOtherData?.description,
      };
      res.push(actualServiceCommonData);
    }
    return res;
  }, []);
}
